var _path;
const _excluded = ["title", "titleId"],
  _excluded2 = ["title", "titleId"],
  _excluded3 = ["className", "color", "size", "pointer"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef, memo } from "react";
import { hooks } from '@approvalmax/utils';
const SVG = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 78,
    height: 74,
    viewBox: "0 0 78 74",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M57.335 36H45V0h19l8 8v28H59.38C57.25 47.328 49.697 54.467 38 57.793V74H0V22h28l10 10v23.714c10.53-3.15 17.28-9.61 19.335-19.714m.339-2a36 36 0 0 0 .318-4.174 3.001 3.001 0 1 1 2 .006A39 39 0 0 1 59.695 34H70V8h-6V2H47v32zM36 58.315C31.26 59.445 25.902 60 20 60v3l-8-4 8-4v3c5.961 0 11.318-.57 16-1.738V32h-8v-8H2v48h34zM72.463 49l2.822 6.05-2.266 1.057-2.85-6.11L66 55V38l12 11z"
  })));
});
const SvgDragNDropIcon = (_ref2, ref) => {
  let {
      title,
      titleId
    } = _ref2,
    props = _objectWithoutProperties(_ref2, _excluded2);
  const {
      className = '',
      color,
      size,
      pointer
    } = props,
    restProps = _objectWithoutProperties(props, _excluded3);
  const isClient = hooks.useOnlyClientRendering();
  const colorClassNameMod = color ? 'am-icon_color-' + color : '';
  const sizeClassNameMod = size ? 'am-icon_size-' + size : '';
  const poinerClassNameMod = pointer ? 'am-icon_pointer' : '';
  const classNames = [className, 'am-icon', colorClassNameMod, sizeClassNameMod, poinerClassNameMod].join(' ');
  if (!isClient) return null;
  return /*#__PURE__*/React.createElement(SVG, _extends({
    className: classNames
  }, restProps));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDragNDropIcon);
const Memo = /*#__PURE__*/memo(ForwardRef);
export { Memo as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI3OCIgaGVpZ2h0PSI3NCIgdmlld0JveD0iMCAwIDc4IDc0Ij4KICAgIDxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgZD0iTTU3LjMzNSAzNkg0NVYwaDE5bDggOHYyOEg1OS4zOEM1Ny4yNSA0Ny4zMjggNDkuNjk3IDU0LjQ2NyAzOCA1Ny43OTNWNzRIMFYyMmgyOGwxMCAxMHYyMy43MTRjMTAuNTMtMy4xNSAxNy4yOC05LjYxIDE5LjMzNS0xOS43MTR6bS4zMzktMmEzNi4yMSAzNi4yMSAwIDAgMCAuMzE4LTQuMTc0IDMuMDAxIDMuMDAxIDAgMSAxIDIgLjAwNkEzOC45MTMgMzguOTEzIDAgMCAxIDU5LjY5NSAzNEg3MFY4aC02VjJINDd2MzJoMTAuNjc0ek0zNiA1OC4zMTVDMzEuMjYgNTkuNDQ1IDI1LjkwMiA2MCAyMCA2MHYzbC04LTQgOC00djNjNS45NjEgMCAxMS4zMTgtLjU3IDE2LTEuNzM4VjMyaC04di04SDJ2NDhoMzRWNTguMzE1ek03Mi40NjMgNDlsMi44MjIgNi4wNS0yLjI2NiAxLjA1Ny0yLjg1LTYuMTFMNjYgNTVWMzhsMTIgMTFoLTUuNTM3eiIvPgo8L3N2Zz4K";